import { render } from "./EnforcementPayment.vue?vue&type=template&id=462f2904&scoped=true"
import script from "./EnforcementPayment.vue?vue&type=script&lang=js"
export * from "./EnforcementPayment.vue?vue&type=script&lang=js"

import "./EnforcementPayment.vue?vue&type=style&index=0&id=462f2904&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462f2904"]])

export default __exports__